import styled from '@emotion/styled'
import { Flex, Title } from '@collable/ui'

interface ManageInfoItemProps {
  title: string
  description?: React.ReactNode
  children?: React.ReactNode
  optionComponent?: React.ReactNode
  resultComponent?: React.ReactNode
  required?: boolean
}

const ManageInfoItem = ({
  title,
  description,
  children,
  optionComponent,
  resultComponent,
  required = false,
}: ManageInfoItemProps) => {
  return (
    <Container>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex direction="column" gap={8}>
          <Flex gap={12} alignItems="center">
            <Title size="subTitle2" fontWeight="bold" as="h3">
              {title}
              {required && <span className="required">*</span>}
            </Title>
            {optionComponent}
          </Flex>
          {description}
        </Flex>
        <ChildrenContainer>{children}</ChildrenContainer>
      </Flex>
      {resultComponent}
    </Container>
  )
}

export default ManageInfoItem

const Container = styled.section`
  width: 100%;
  border-radius: 20px;
  padding: 24px;
  background-color: ${({ theme }) => theme.fill.fillAssistive};

  .required {
    margin-left: 6px;
    color: ${({ theme }) => theme.status.statusCautionary};
  }
`

const ChildrenContainer = styled.div`
  width: 320px;
`
